import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import '../Connect/Connect.css';
import './Portfolio.css';

export default function PortfolioShell({ children, className = '' }) {
  const { pathname, search } = useLocation();
  const isHome = pathname === '/';

  return (
    <div className={`portfolio-page connect-page ${className}`.trim()}>
      <Link className="pf-skip-link" to={{ pathname, search, hash: '#portfolio-main' }} onClick={() => document.getElementById('portfolio-main')?.focus({ preventScroll: true })}>Skip to content</Link>
      <header className="connect-nav pf-header">
          <Link className="connect-brand pf-brand" to="/" aria-label="Robert Miller home">Robert Miller</Link>
          <nav className="pf-nav" aria-label="Main navigation">
            {!isHome && <Link className="pf-nav-link pf-nav-home" to="/"><span aria-hidden="true">←</span> Back to home</Link>}
            <NavLink className={({ isActive }) => `pf-nav-link${isActive ? ' pf-nav-current' : ''}`} to="/notes">Notes</NavLink>
            <NavLink className={({ isActive }) => `pf-nav-link${isActive ? ' pf-nav-current' : ''}`} to="/background">Background</NavLink>
            <Link className="pf-nav-link" to="/connect">Connect</Link>
          </nav>
      </header>
      <main id="portfolio-main" tabIndex="-1">{children}</main>
      <footer className="pf-footer">
        <div className="portfolio-container pf-footer-inner">
          <div>
            <Link className="pf-footer-name" to="/">Robert Miller</Link>
            <p>Software architecture · Applied AI</p>
          </div>
          <div className="pf-footer-meta">
            <span>© 2023–2026 Robert Miller</span>
            <Link to="/credits">Credits</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
